/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/* global FormData */
define([
	'dashboard-analytics/widgets/livewidget/nls/StringResources',
	'../../../util/VidaSdkUtil',
	'../../../visualizations/vipr/VIPRLibraries',
	'../../../visualizations/vipr/VIPR',
	'../../../lib/@waca/dashboard-common/dist/api/Error'
], function(
	StringResources,
	VidaSdkUtil,
	VIPRLibraries,
	VIPR,
	APIError
) {
	return class VisUtil {

		static validateVisDefinition(content, dashboard, options = {}) {
			const definition = content.getFeature('Visualization').getDefinition();
			const visId = definition ? definition.getId() : options.visId;
			const isSystemVis = definition && VIPRLibraries.isSystemLib(definition.getId(), VIPR.getSystemLibIds());

			if (isSystemVis) {
				return Promise.resolve(true);
			}

			const contentState = content.getFeature('state.internal');
			//First clear previous error load definition first before validate again to pick up the latest definition state cached in the user session
			if (contentState) {
				const error = contentState.getError();

				if (error && error.getParams) {
					const params = error.getParams() || {};

					if (params.errorInfo && params.errorInfo.errorCode === VIPRLibraries.LOAD_DEFINITION_ERROR) {
						contentState.clearError();
					}
				}
			}

			if (visId === 'visualizationPreview') {
				return VidaSdkUtil.isSDKActive(dashboard)
					.then(isActive => {
						if (!isActive) {
							VisUtil._setError(contentState, visId);
						}
						return isActive;
					});
			} else {
				const definitionError = definition.getState().getError();
				if (!definitionError) {
					return Promise.resolve(true);
				} else {
					VisUtil._setError(contentState, visId, definitionError);
					return Promise.resolve(false);
				}
			}
		}

		static _setError(stateAPI, visId, error) {
			if (stateAPI) {
				const errorToSet = (error instanceof APIError) ? error : VisUtil.createVisDefinitionLoadingError(visId);
				stateAPI.setError(errorToSet);
			}
		}

		static createVisDefinitionLoadingError(visId) {
			const msg = StringResources.get('loadVisDefinitionError', { id: visId });
			return new APIError({
				msg: msg,
				params: {
					errorInfo: {
						id: visId,
						errorCode: VIPRLibraries.LOAD_DEFINITION_ERROR,
						errorMessage: msg
					}
				}
			});
		}
	};
});
